export default __webpack_public_path__ + "static/media/logo_multicar_rect_black.3d546270.webp";